import React from "react";
import { useTranslation } from "react-i18next";
import { AdminUser } from "../../features/admin/models/AdminUser";
import { formatAdminTimestamp } from "../../features/admin/utils/formatAdminTimestamp";

interface AdminUserActivitySummaryProps {
  user: AdminUser;
}

/**
 * "Sessions 3 · Contracts 1 · Visits 5 · Last active 28 Oct 2026, 09:14" — activity at a glance.
 * "No activity yet" means no records yet: lastActiveAt also moves at sign-up, so it can't say that.
 */
const AdminUserActivitySummary: React.FC<AdminUserActivitySummaryProps> = ({ user }) => {
  const { t } = useTranslation();
  const hasRecords = user.memberCount + user.sessionCount + user.contractCount + user.visitCount > 0;
  const lastActive = hasRecords && user.lastActiveAt
    ? formatAdminTimestamp(user.lastActiveAt)
    : t("admin.activity.never");

  return (
    <p className="mt-1 text-xs text-grey-50 dark:text-grey-60">
      {[
        `${t("admin.activity.sessions")} ${user.sessionCount}`,
        `${t("admin.activity.contracts")} ${user.contractCount}`,
        `${t("admin.activity.visits")} ${user.visitCount}`,
        `${t("admin.activity.lastActive")} ${lastActive}`,
      ].join(" · ")}
    </p>
  );
};

export default AdminUserActivitySummary;
